import { Injectable, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AuthResponseTokenComponent } from "../authentication/auth-response-token.component";

@Injectable({
  providedIn: "root",
})
export class ModalService {
  private dialog = inject(MatDialog);

  public openLoginPopup(type: string) {
    this.dialog.open(AuthResponseTokenComponent, {
      data: {
        type: type,
      },
    });
    return Promise.resolve(false);
  }
}
